import { RootfiSyncConfig } from '@commenda/types';
import { RootfiCompanyUseCase } from '@prisma/client';

import {
  BOOKKEEPING_SYNC_CONFIG,
  OPERATIONAL_TRANSFER_PRICING_SYNC_CONFIG,
  SALES_TAX_ACCOUNTING_SYNC_CONFIG,
  SALES_TAX_ECOMMERCE_SYNC_CONFIG,
  SALES_TAX_PAYMENTS_SYNC_CONFIG,
} from './syncConfigs';

const ROOTFI_SYNC_CONFIG = [
  ...SALES_TAX_ACCOUNTING_SYNC_CONFIG,
  ...SALES_TAX_ECOMMERCE_SYNC_CONFIG,
  ...SALES_TAX_PAYMENTS_SYNC_CONFIG,
];

export const getSyncConfigMap = (
  useCase: RootfiCompanyUseCase
): RootfiSyncConfig[] => {
  switch (useCase) {
    case RootfiCompanyUseCase.OPERATIONAL_TRANSFER_PRICING:
      return OPERATIONAL_TRANSFER_PRICING_SYNC_CONFIG;
    case RootfiCompanyUseCase.BOOKKEEPING:
      return BOOKKEEPING_SYNC_CONFIG;
    case RootfiCompanyUseCase.SALES_TAX:
      return ROOTFI_SYNC_CONFIG;
    default:
      throw new Error(`Unsupported RootFi use case: ${useCase}`);
  }
};
